import type { IResponseBase } from '@/interfaces';
import type { PefinExclusionReason, PefinResponse } from '@/models/dto/Pefin.dto';
import { Http } from './http';

const http = Http.create();

export class PefinService {
	static async getByCase(caseId: string) {
		const response = await http.get<IResponseBase<PefinResponse | null>>(`/pefin/${caseId}`);
		return response.data;
	}

	static async getCompleteByCase(caseId: string) {
		const response = await http.get<IResponseBase<PefinResponse[]>>(
			`/pefin/${caseId}/complete`,
		);
		return response.data;
	}

	static async create(caseId: string) {
		const response = await http.post<IResponseBase<PefinResponse>>(`/pefin`, { caseId });
		return response.data;
	}

	static async deleteByCase(caseId: string, reason: PefinExclusionReason) {
		const response = await http.delete<IResponseBase<PefinResponse | null>>(
			`/pefin/${caseId}`,
			{ data: { reason } },
		);
		return response.data;
	}

	static async retryTransaction(transactionId: string) {
		const response = await http.post<IResponseBase<PefinResponse>>(
			`/pefin/transaction/${transactionId}/retry`,
		);
		return response.data;
	}
}

export default PefinService;
